/** Default visible columns in left-to-right display order (table schema order can differ). */
export const LANDLORD_TABLE_DEFAULT_VISIBLE_KEYS = [
  'name',
  'primary_contact',
  'email_address',
  'total_buildings',
  'total_units',
  'sf_createdDate',
  'actions',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const LANDLORD_TABLE_STORAGE_KEY = 'company-list-v2';
